import { ScrollView } from 'react-native';
import { useTranslation } from 'react-i18next';
import { VStack } from '@/components/gluestack/vstack';
import { HStack } from '@/components/gluestack/hstack';
import { Text } from '@/components/gluestack/text';
import { Button, ButtonText } from '@/components/gluestack/button';
import { RenderHtml } from '@/components/ui/RenderHtml';
import { DRAWER_SCROLL_CLASSES, type IContextSheetContentProps, type ISheetConfig } from '@/components/ui/ContextSheet';

export default function LocationPermissionHelp({ onClose }: IContextSheetContentProps) {
  const { t } = useTranslation();
  return (
    <VStack className="flex-1 gap-3">
      <ScrollView {...DRAWER_SCROLL_CLASSES}>
        <VStack className="gap-3">
          <Text className="font-semibold">
            {t('settings.location.enableHelpBlocked', 'Your browser is currently blocking access to your location')}
          </Text>
          <RenderHtml
            html={t('settings.location.enableHelpSteps', 'To enable it, follow the steps below:\n\n\u2022 Open the site information menu near the address bar (lock or settings or info icon).\n\u2022 Find Permissions for this site and locate the Location setting.\n\u2022 Change Location to Allow (or Ask each time).\n\u2022 Reload the page.')}
            size="sm"
            className="text-typography-700"
            noTruncate
          />
        </VStack>
      </ScrollView>
      <HStack className="shrink-0 justify-end">
        <Button size="md" onPress={onClose}>
          <ButtonText>{t('common.done')}</ButtonText>
        </Button>
      </HStack>
    </VStack>
  );
}

LocationPermissionHelp.sheetConfig = {
  largeScreenMode: 'modal',
  size: 'sm',
  height: 'lg',
  scrollableContent: true,
} satisfies ISheetConfig;
